import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import * as AppConstants from '../AppConstants';
import moment from 'moment';
import noImage from '../images/noimage.png';
import fire from '../images/fire.svg';
import { MessageCircle, ExternalLink } from 'react-feather';
import { getSysSetting, numberWithCommas, handleSmallImages } from '../Utils';
import axios from 'axios';
import thumbsDownIcon from '../images/thumbs-down.svg';
import thumbsUpIcon from '../images/thumbs-up.svg';

export class PropertyCard extends Component {
  static displayName = PropertyCard.name;

  constructor(props) {
    super(props);
    const initialThumbs = props?.buyerProperty?.rating === 5
      ? 'up'
      : props?.buyerProperty?.rating === 1
      ? 'down'
      : null;
    this.state = {
      thumbsState: initialThumbs,
    };
  }

  // fixmeadd: Handler to save propertyRef before navigation
  handleImageClick = (e) => {
    const propertyRef = this.props.property?.propertyRef;
    if (propertyRef) {
      localStorage.setItem('PropertySearchRef', propertyRef);
      console.log('Saved propertyRef:', propertyRef);
    } else {
      console.warn('No propertyRef found for property:', this.props.property);
    }
    // Navigation will proceed via Link
  };

  handleThumbUp = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const id = this.props.buyerProperty?.id;
    if (!id) return;
    // Toggle: if already up -> clear; else set up
    const next = this.state.thumbsState === 'up' ? null : 'up';
    this.setState({ thumbsState: next });
    // Fire-and-forget
    axios.get(`/BuyerProperty/BuyerPropertyThumbsUp/${id}`).catch(() => {});
  };

  handleThumbDown = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const id = this.props.buyerProperty?.id;
    if (!id) return;
    // Toggle: if already down -> clear; else set down
    const next = this.state.thumbsState === 'down' ? null : 'down';
    this.setState({ thumbsState: next });
    // Fire-and-forget
    axios.get(`/BuyerProperty/BuyerPropertyThumbsDown/${id}`).catch(() => {});
  };

  renderRemarks() {
    if (this.props.showRemarks === true) {
      const dateOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const formattedDate = this.props.property?.dateChanged
        ? new Date(this.props.property.dateChanged).toLocaleDateString('en-GB', dateOptions)
        : '';
      return (
        <div>
          <div className="row mt-3">
            <div className="col-10">
              <p className="m-0">
                <span className="font-weight-bold">
                  <i className="fas fa-info fa-lg mr-2 ml-1"></i>
                </span>
                {formattedDate}
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-10">
              <p className="m-0 font-weight-bold">
                {this.props.property?.remarks}
              </p>
            </div>
          </div>
        </div>
      );
    }
  }

  renderFavouriteRemoveBtn() {
    if (this.props.showRemoveFavouriteBtn === true) {
      return (
        <p
          className="property-action-btn property-action-btn--danger d-inline-flex align-items-center justify-content-center mb-0 mt-2"
          onClick={() =>
            this.props.mutation.mutate({
              id: this.props.property?.favouriteObj?.id,
              propertyRef: this.props.property?.propertyRef,
            })
          }
          title="Remove favourite"
        >
          <i className="fas fa-trash"></i>
        </p>
      );
    }
  }

  renderGoToWebsiteBtn() {
    if (this.props.property?.showingOnWeb === true) {
      let url =
        getSysSetting(AppConstants.SysSettingId_PropertyWebUrl)?.stringValue +
        this.props.property?.propertyRef;
      return (
        <button
          type="button"
          className="property-action-btn"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.open(url, '_blank', 'noopener,noreferrer');
          }}
          title="Open on web"
        >
          <ExternalLink size={16} />
        </button>
      );
    }
  }

  renderAddToFavouritesBtn() {
    if (this.props.showFavouriteBtn === true) {
      return (
        <button
          type="button"
          className="property-action-btn"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.reasonModal(
              e,
              this.props.property?.id,
              this.props.property?.propertyRef,
            );
          }}
          title="Add to favourites"
        >
          <i className="far fa-heart"></i>
        </button>
      );
    }
  }

  renderAddToHotPropertiesBtn() {
    if (this.props.showHotBtn === true) {
      return (
        <button
          type="button"
          className="property-action-btn"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.reasonModal(
              e,
              this.props.property?.id,
              this.props.property?.propertyRef,
              20, // Hot Property Reason Id
            );
          }}
          title="Mark as hot"
        >
          <img
            className="me-1"
            src={fire}
            alt="hot"
            style={{ width: '14px', height: '20px' }}
          />
        </button>
      );
    }
  }

  renderLeaveFeedbackBtn() {
    if (this.props.showFeedbackBtn === true) {
      return (
        <button
          type="button"
          className="property-action-btn"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.feedbackModal(
              e,
              this.props.property?.id,
              this.props.property?.propertyRef,
              this.props.buyerProperty?.id,
            );
          }}
          title="Leave feedback"
        >
          <MessageCircle size={16} />
        </button>
      );
    }
  }

  renderSelectCheckbox() {
    if (this.props.showSelectCheckbox === true) {
      return (
        <div className="property-action-checkbox">
          <input
            type="checkbox"
            name="propertyId[]"
            value={this.props.property?.id}
            className="property-checkbox-input"
            onClick={this.props.handleCheck}
            data-property={JSON.stringify(this.props.property)}
            id={`prop-${this.props.property?.id}`}
          />
        </div>
      );
    }
  }

  renderBuyerPropertyRemoveBtn() {
    if (this.props.showRemoveBuyerPropertyBtn === true) {
      return (
        <p
          className="property-action-btn property-action-btn--danger d-inline-flex align-items-center justify-content-center mb-0 mt-2"
          onClick={() =>
            this.props.mutation.mutate({
              id: this.props.buyerProperty?.id,
              propertyRef: this.props.property?.propertyRef,
            })
          }
          title="Remove"
        >
          <i className="fas fa-trash"></i>
        </p>
      );
    }
  }

  render() {
    return (
      <div className="col-12 col-md-6 col-xl-4 mb-3" key={this.props.index}>
        <div className="card shadow-sm rounded-3 overflow-hidden">
        <div className="position-relative">
          <Link
            to={{
              pathname: '/PropertyDetails',
            }}
            state={{
              query: {
                property: this.props.property,
              },
              prevPath: { path: this.props.location.pathname },
            }}
            style={{
              textDecoration: 'none',
              color: 'black',
            }}
            onClick={this.handleImageClick} // fixmeadd: Save propertyRef
          >
            {this.props.property?.coverImg != null ? (
              <img
                src={(function () {
                  const raw = String(this.props.property.coverImg || "");

                  // Build an absolute URL using the URL API (handles relative vs absolute safely)
                  const u = new URL(raw, AppConstants.BASE_URL_FILE);

                  // Normalize ONLY the path
                  u.pathname = u.pathname
                    .replace(/\\/g, "/")           // backslashes → slashes
                    .replace(/\/{2,}/g, "/")       // collapse //
                    .replace(/^\/(?:files\/)+/i, "/Files/"); // dedupe leading /Files/Files/… → /Files/

                  return u.toString();
                }).call(this)}
                alt="firstImage"
                className="img-fluid w-100 thumb-image card-img-top"
                data-property-ref={this.props.property?.propertyRef}
              />
            ) : (
              <img
                src={noImage}
                alt="defaultImage"
                className="img-fluid w-100 thumb-image card-img-top"
                data-property-ref={this.props.property?.propertyRef}
              />
            )}
          </Link>
          {typeof this.props.property?.forSaleOrToLet === 'boolean' && (
            this.props.property.forSaleOrToLet === false ? (
              <small
                className="for-Sale-or-for-Let"
                style={{ background: 'green', padding: '2px' }}
              >
                For Sale
              </small>
            ) : (
              <small
                className="for-Sale-or-for-Let"
                style={{ background: 'red', padding: '2px' }}
              >
                To Let
              </small>
            )
          )}
          <small className="ribbon">Ref:{this.props.property?.propertyRef}</small>
        </div>
        <div className="non card-body">
          <p className="mb-1 title fw-bold mt-2 text-truncate">
            {`${this.props.property?.propertyTypeName ?? ''}`}{this.props.property?.localityName ? ` • ${this.props.property?.localityName}` : ''}
          </p>
          {(this.props.property?.propertyStateName || this.props.property?.areaSqMtrs) && (
            <div className="d-flex justify-content-between align-items-center text-muted small mb-1">
              <span className="text-truncate">{this.props.property?.propertyStateName}</span>
              {this.props.property?.bedrooms != null && (
                <span className="text-muted small">
                  <i className="fas fa-bed me-1"></i>
                  {this.props.property?.bedrooms}
                </span>
              )}
            </div>
          )}
          <div className="d-flex justify-content-between align-items-center mb-1">
            <span className="price fw-bold">
            €
            {this.props.property?.forSaleOrToLet === false
              ? numberWithCommas(this.props.property?.propertyForSale?.price)
              : numberWithCommas(this.props.property?.propertyToLet?.longLetRate) +
                ' ' +
                this.props.property?.propertyToLet?.leaseRatePeriod}
            </span>
            {this.props.property?.areaSqMtrs != null && (
                <span><i className="fas fa-expand me-1"></i>{this.props.property?.areaSqMtrs}</span>
            )}
          </div>
          {this.props.property?.forSaleOrToLet === true &&
            this.props.property?.propertyToLet?.lettingNextAvail && (
              <p className="mb-1 text-muted small">
                <i className="fas fa-clock me-1"></i>
                {moment(this.props.property.propertyToLet.lettingNextAvail).format('DD/MM/YYYY')}
              </p>
          )}
          
          <div className="d-flex align-items-center flex-wrap gap-2 mt-3">
            <div className="property-actions">
              <div className="property-actions-left">
                {this.renderGoToWebsiteBtn()}
                {this.renderAddToFavouritesBtn()}
                {this.renderAddToHotPropertiesBtn()}
                {this.renderLeaveFeedbackBtn()}
            {this.props.buyerProperty ? (
              <>
                <button
                  type="button"
                  className={`property-action-btn ${this.state.thumbsState === 'down' ? 'property-action-btn--danger' : ''}`}
                  onClick={this.handleThumbDown}
                  title="Thumbs down"
                >
                  <img src={thumbsDownIcon} alt="thumbs-down" style={{ width: '18px', height: '18px' }} />
                </button>
                <button
                  type="button"
                  className={`property-action-btn ${this.state.thumbsState === 'up' ? 'property-action-btn--success' : ''}`}
                  onClick={this.handleThumbUp}
                  title="Thumbs up"
                >
                  <img src={thumbsUpIcon} alt="thumbs-up" style={{ width: '18px', height: '18px' }} />
                </button>
              </>
            ) : null}
              </div>
              <div className="property-actions-end">
                {this.renderSelectCheckbox()}
                {this.renderFavouriteRemoveBtn()}
                {this.renderBuyerPropertyRemoveBtn()}
              </div>
            </div>
          </div>
          {this.renderRemarks()}
        </div>
        </div>
      </div>
    );
  }
}
